import { connect } from "react-redux";
import {
  getFeature,
  getFeaturesLoaded
} from "@template/state/modules/features";
import SignalScriptLoader from "./SignalScriptLoader";

const mapStateToProps = state => {
  const { isSignalEnabledInBrowseSite = false } =
    (getFeaturesLoaded(state) && getFeature(state, "ssc-browse")) || {};
  return {
    isSignalEnabledInBrowseSite
  };
};

export default connect(mapStateToProps, null)(SignalScriptLoader);
